import OpenSansBoldFont from "./assets/fonts/OpenSans-Bold.ttf";
import OpenSansBoldItalicFont from "./assets/fonts/OpenSans-BoldItalic.ttf";
import OpenSansExtraBoldFont from "./assets/fonts/OpenSans-ExtraBold.ttf";
import OpenSansExtraBoldItalicFont from "./assets/fonts/OpenSans-ExtraBoldItalic.ttf";
import OpenSansItalicFont from "./assets/fonts/OpenSans-Italic.ttf";
import OpenSansLightFont from "./assets/fonts/OpenSans-Light.ttf";
import OpenSansLightItalicFont from "./assets/fonts/OpenSans-LightItalic.ttf";
import OpenSansMediumFont from "./assets/fonts/OpenSans-Medium.ttf";
import OpenSansMediumItalicFont from "./assets/fonts/OpenSans-MediumItalic.ttf";
import OpenSansRegularFont from "./assets/fonts/OpenSans-Regular.ttf";
import OpenSansSemiBoldFont from "./assets/fonts/OpenSans-SemiBold.ttf";
import OpenSansSemiBoldItalicFont from "./assets/fonts/OpenSans-SemiBoldItalic.ttf";

export const OpenSansLight = {
  fontFamily: "OpenSans",
  fontStyle: "normal",
  fontWeight: 300,
  src: `
    url(${OpenSansLightFont}) format('truetype')
  `,
  unicodeRange:
    "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
};

export const OpenSansLightItalic = {
  fontFamily: "OpenSans",
  fontStyle: "italic",
  fontWeight: 300,
  src: `
    url(${OpenSansLightItalicFont}) format('truetype')
  `,
  unicodeRange:
    "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
};

export const OpenSans = {
  fontFamily: "OpenSans",
  fontStyle: "normal",
  fontWeight: 400,
  src: `
    url(${OpenSansRegularFont}) format('truetype')
  `,
  unicodeRange:
    "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
};

export const OpenSansItalic = {
  fontFamily: "OpenSans",
  fontStyle: "italic",
  fontWeight: 400,
  src: `
    url(${OpenSansItalicFont}) format('truetype')
  `,
  unicodeRange:
    "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
};

export const OpenSansMedium = {
  fontFamily: "OpenSans",
  fontStyle: "normal",
  fontWeight: 500,
  src: `
      url(${OpenSansMediumFont}) format('truetype')
    `,
  unicodeRange:
    "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
};

export const OpenSansMediumItalic = {
  fontFamily: "OpenSans",
  fontStyle: "italic",
  fontWeight: 500,
  src: `
      url(${OpenSansMediumItalicFont}) format('truetype')
    `,
  unicodeRange:
    "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
};

export const OpenSansSemiBold = {
  fontFamily: "OpenSans",
  fontStyle: "normal",
  fontWeight: 600,
  src: `
      url(${OpenSansSemiBoldFont}) format('truetype')
    `,
  unicodeRange:
    "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
};

export const OpenSansSemiBoldItalic = {
  fontFamily: "OpenSans",
  fontStyle: "italic",
  fontWeight: 600,
  src: `
      url(${OpenSansSemiBoldItalicFont}) format('truetype')
    `,
  unicodeRange:
    "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
};

export const OpenSansBold = {
  fontFamily: "OpenSans",
  fontStyle: "normal",
  fontWeight: 700,
  src: `
      url(${OpenSansBoldFont}) format('truetype')
    `,
  unicodeRange:
    "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
};

export const OpenSansBoldItalic = {
  fontFamily: "OpenSans",
  fontStyle: "italic",
  fontWeight: 700,
  src: `
      url(${OpenSansBoldItalicFont}) format('truetype')
    `,
  unicodeRange:
    "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
};

export const OpenSansExtraBold = {
  fontFamily: "OpenSans",
  fontStyle: "normal",
  fontWeight: 800,
  src: `
      url(${OpenSansExtraBoldFont}) format('truetype')
    `,
  unicodeRange:
    "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
};

export const OpenSansExtraBoldItalic = {
  fontFamily: "OpenSans",
  fontStyle: "italic",
  fontWeight: 800,
  src: `
      url(${OpenSansExtraBoldItalicFont}) format('truetype')
    `,
  unicodeRange:
    "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
};
